import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Alert,
  Grid,
} from "@mui/material";
import api from "../api";

const Exportar = () => {
  const hoje = new Date();
  const [anoInicio, setAnoInicio] = useState(hoje.getFullYear());
  const [mesInicio, setMesInicio] = useState(0);
  const [anoFim, setAnoFim] = useState(hoje.getFullYear());
  const [mesFim, setMesFim] = useState(hoje.getMonth());
  const [mensagem, setMensagem] = useState("");

  const anosPermitidos = Array.from(
    { length: hoje.getFullYear() - 2020 + 1 },
    (_, i) => hoje.getFullYear() - i
  );

  const meses = Array.from({ length: 12 }, (_, i) => i);

  const handleExportar = async () => {
    try {
      const response = await api.get(`/lancamentos/exportar`, {
        params: {
          anoInicio,
          mesInicio: mesInicio + 1,
          anoFim,
          mesFim: mesFim + 1,
        },
        responseType: "blob", // Garantir que a resposta seja tratada como blob (arquivo)
      });

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `lancamentos_${anoInicio}-${mesInicio + 1}_a_${anoFim}-${
          mesFim + 1
        }.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setMensagem("Arquivo exportado com sucesso.");
    } catch (error) {
      console.error("Erro ao exportar arquivo:", error);
      setMensagem(
        "Erro ao exportar o arquivo. Verifique o período selecionado."
      );
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography
        variant="h4"
        mb={3}
        sx={{ textAlign: "center", fontWeight: "bold" }}
      >
        Exportar Dados
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="ano-inicio-label">Ano Início</InputLabel>
            <Select
              labelId="ano-inicio-label"
              value={anoInicio}
              onChange={(e) => setAnoInicio(e.target.value)}
              label="Ano Início"
            >
              {anosPermitidos.map((ano) => (
                <MenuItem key={ano} value={ano}>
                  {ano}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="mes-inicio-label">Mês Início</InputLabel>
            <Select
              labelId="mes-inicio-label"
              value={mesInicio}
              onChange={(e) => setMesInicio(e.target.value)}
              label="Mês Início"
            >
              {meses.map((mes) => (
                <MenuItem key={mes} value={mes}>
                  {new Date(0, mes).toLocaleString("pt-BR", { month: "long" })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="ano-fim-label">Ano Fim</InputLabel>
            <Select
              labelId="ano-fim-label"
              value={anoFim}
              onChange={(e) => setAnoFim(e.target.value)}
              label="Ano Fim"
            >
              {anosPermitidos.map((ano) => (
                <MenuItem key={ano} value={ano}>
                  {ano}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel id="mes-fim-label">Mês Fim</InputLabel>
            <Select
              labelId="mes-fim-label"
              value={mesFim}
              onChange={(e) => setMesFim(e.target.value)}
              label="Mês Fim"
            >
              {meses.map((mes) => (
                <MenuItem key={mes} value={mes}>
                  {new Date(0, mes).toLocaleString("pt-BR", { month: "long" })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleExportar}
          disabled={
            anoInicio > anoFim || (anoInicio === anoFim && mesInicio > mesFim)
          }
        >
          Exportar
        </Button>
      </Box>

      {mensagem && (
        <Alert
          severity={mensagem.includes("sucesso") ? "success" : "error"}
          sx={{ mt: 2 }}
        >
          {mensagem}
        </Alert>
      )}
    </Box>
  );
};

export default Exportar;
